import React from 'react';
import { string, bool, func, oneOf } from 'prop-types';
import classnames from 'classnames';
import compose from 'lodash/flowRight';
import { multipleFiltersAttributesShape } from 'shapes';
import { connectMultipleFilters, withCleanCategoryHeader } from 'connectors';
import '../QuickFilters.scss';

const QUICKFILTERS_CARD_MODE = {
    GRID: 'grid',
    LIST: 'list',
};

function QuickFilters(props) {
    const {
        buttonClassName,
        className,
        title,
        name,
        captionTitle,
        refine,
        attributes,
        cleanCategoryHeader,
        isInCategorySearch,
        mode,
    } = props;

    const onClick = () => {
        if (isInCategorySearch) cleanCategoryHeader();
        refine(attributes);
    };

    const rootClassname = classnames(
        className,
        'quickfilters',
        'product-card-root',
        'products__product',
        {
            'quickfilters--grid': mode === QUICKFILTERS_CARD_MODE.GRID,
        },
    );
    const buttonRootClass = classnames(
        'button quickfilters-button',
        buttonClassName,
    );

    return (
        <button
            className={rootClassname}
            data-qa="quickFiltersEl"
            onClick={onClick}
        >
            <div className="quickfilters-text-wrapper">
                {name && <div className="quickfilters-label">{name}</div>}
                <div className="quickfilters-question">{title}</div>
            </div>
            <div className={buttonRootClass} data-qa="quickFiltersCta">
                {captionTitle}
            </div>
        </button>
    );
}

QuickFilters.propTypes = {
    className: string,
    buttonClassName: string,
    attributes: multipleFiltersAttributesShape.isRequired,
    name: string,
    captionTitle: string.isRequired,
    title: string.isRequired,
    refine: func.isRequired,
    cleanCategoryHeader: func.isRequired,
    isInCategorySearch: bool,
    mode: oneOf([QUICKFILTERS_CARD_MODE.GRID, QUICKFILTERS_CARD_MODE.LIST]),
};

QuickFilters.defaultProps = {
    className: null,
    buttonClassName: null,
    name: null,
    isInCategorySearch: false,
    mode: QUICKFILTERS_CARD_MODE.GRID,
};

export default compose(
    connectMultipleFilters,
    withCleanCategoryHeader,
)(QuickFilters);
